export const UNAUTHORIZED_ACCESS = "Unauthorized access";
export const REGION = "region";
export const AUTHORIZATION = "ngn-auth-token";

export const DATE_FORMAT = "dd/MM/yyyy";
export const DATE_FORMAT_YYYY = "yyyy-MM-dd";

// REGIONS
export const REGION_NAME_LIST = {
  AE: {
    name: "United Arab Emirates",
    code: "AE",
  },
  EG: {
    name: "Egypt",
    code: "EG",
  },
};
